export default {
	badges: {
		activeBid: {
			ended: 'Sale over - processing',
			endsIn: 'Sale ends in{timeLeft}',
		},
		didntWin: 'Sold for {soldFor}',
		underOffer: 'Under offer',
	},
	cell: {
		bidOfferCell: {
			bid: 'Your max bid',
			offer: 'Your offer',
		},
	},
	headers: {
		dateBid: 'Date bid',
		maxBidOffer: 'Bid / offer',
		status: {
			active: 'Status',
			'didnt-win': 'Sale price',
			'under-offer': 'Status',
		},
		vehicle: 'Vehicle',
	},
};
